import React from 'react';
import { useState } from 'react';
import Navigation from '../Navigation';
import AppointementHeader from './AppointementHeader';
import AvailableAppointement from './AvailableAppointement';
import bg from '../../img/alyssa-hurley-yekIZ4ltv1o-unsplash.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css';
const Appointement = () => {
    const [date, setDate] = useState(new Date());
    const appointmentBanner = {
        background: `url(${bg})`,
        // backgroundColor: '#958B8B',
        backgroundBlendMode: 'multiply',
        height: '100%',
        backgroundPosition: 'center',
        backgroundRepeat: ' no-repeat',
        backgroundSize: 'cover',
        // opacity: '3.9'style={appointmentBanner}

    }
    AOS.init();

    return (

        <div


            className=''>
            <Navigation></Navigation>
            <div style={appointmentBanner}>
                <AppointementHeader date={date} setDate={setDate} ></AppointementHeader>
                <AvailableAppointement date={date}></AvailableAppointement>
            </div>
        </div>
    );
};

export default Appointement;